import I18n from 'I18n';
import Raven from 'raven-js';
import { useDispatch } from 'react-redux';
import { useCallback, useEffect, useState } from 'react';
import { removeTeaseAlert } from '../../actions/TeaseActions';
import { DELIVERY_METHOD_NAMES, TEASE_ALERT_MINIMUM_TIMEOUT } from '../../constants';
import { Alert } from 'foundations-components/transitional/components/Alert';
import { Button } from 'foundations-components/transitional/components/Button';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { turnOnNotification } from '../../api/notificationsApi';
import { StyledTeaseBase } from 'notifications-display';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledAlertContainer = StyledTeaseBase;
const getMessageKey = (alert, isUndone) => {
  switch (alert.kind) {
    case 'sound-off':
      if (isUndone) {
        return alert.translatedDpgName ? 'sidebar.popupToastMessage.unmutedDescriptionWithDpg' : 'sidebar.popupToastMessage.unmutedDescription';
      }
      return alert.translatedDpgName ? 'sidebar.popupToastMessage.mutedDescriptionWithDpg' : 'sidebar.popupToastMessage.mutedDescription';
    case 'notification-off':
      if (isUndone) {
        return alert.translatedDpgName ? 'sidebar.popupToastMessage.turnedOnDescriptionWithDpg' : 'sidebar.popupToastMessage.turnedOnDescription';
      }
      return alert.translatedDpgName ? 'sidebar.popupToastMessage.turnedOffDescriptionWithDpg' : 'sidebar.popupToastMessage.turnedOnDescription';
    default:
      throw new Error(`Unknown kind "${alert.kind}" cannot find a message key`);
  }
};
const TeaseAlert = ({
  alert
}) => {
  const canUndo = alert.kind === 'notification-off';
  const [isOpen, setIsOpen] = useState(true);
  const [isUndone, setIsUndone] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const dispatch = useDispatch();
  const onAnimationEnd = useCallback(() => {
    if (!isOpen) {
      dispatch(removeTeaseAlert(alert.id));
    }
  }, [isOpen, dispatch, alert.id]);
  const onClose = useCallback(() => setIsOpen(false), []);
  const onMouseEnter = useCallback(() => setIsHovered(true), [setIsHovered]);
  const onMouseLeave = useCallback(() => setIsHovered(false), [setIsHovered]);
  const onUndo = useCallback(() => {
    setIsUndone(true);
    turnOnNotification({
      id: alert.id,
      deliveryMethod: DELIVERY_METHOD_NAMES.TEASE
    }).catch(e => {
      Raven.captureException(e);
    });
  }, [alert.id]);
  useEffect(() => {
    const timer = isHovered ? undefined : setTimeout(() => setIsOpen(false), TEASE_ALERT_MINIMUM_TIMEOUT);
    return () => clearTimeout(timer);
  }, [isHovered]);
  return /*#__PURE__*/_jsx(StyledAlertContainer, {
    isOpen: isOpen,
    onAnimationEnd: onAnimationEnd,
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave,
    children: /*#__PURE__*/_jsxs(Alert, {
      closeable: true,
      type: "success",
      onClose: onClose,
      titleText: I18n.text('sidebar.optToastMessage.title'),
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        "data-test-id": "tease-alert-body",
        message: getMessageKey(alert, isUndone),
        options: {
          DPG: alert.translatedDpgName
        }
      }), !isUndone && canUndo ? /*#__PURE__*/_jsxs(_Fragment, {
        children: [' ', /*#__PURE__*/_jsx(Button, {
          "data-test-id": "tease-alert-undo-button",
          size: "extra-small",
          use: "link",
          onClick: onUndo,
          children: /*#__PURE__*/_jsx(View, {
            inlineSize: "initial",
            children: I18n.text('sidebar.optToastMessage.undoLink')
          })
        })]
      }) : null]
    })
  });
};
export default TeaseAlert;